import FastMarquee from "react-fast-marquee";
import { Zap } from "lucide-react";
import { site } from "@/data/site";

export default function Marquee({ gold = false }) {
  return (
    <div
      className={`relative overflow-hidden border-y py-6 ${
        gold ? "border-gold/30 bg-[#0D0B05]" : "border-purple/30 bg-[#0B0810]"
      }`}
      data-testid={gold ? "marquee-gold" : "marquee-purple"}
    >
      <FastMarquee speed={35} gradient={false}>
        {site.marquee.map((word, i) => (
          <span key={word} className="mx-6 flex items-center gap-6">
            <span className="whitespace-nowrap font-display text-2xl font-black uppercase tracking-tight text-white lg:text-4xl">
              {word}
            </span>
            <Zap className={`h-5 w-5 ${gold ? "text-gold" : "text-purple"}`} fill="currentColor" />
          </span>
        ))}
      </FastMarquee>
    </div>
  );
}
